export const AppConstants = {
  VENDOR_INSTITUTION_ID_HBL: 'HBL',
  WEB_APPLICATION_NAME: 'onlinebanking',
  WEB_APPLICATION_VERSION: '2.0.0',
  WEB_APPLICATION_BUILD: '001',
  WEB_APPLICATION_PACKAGE_ID: 'com.mobilearth.web',
  APP_TESTING_PACKAGE_ID: 'com.mobilearth.mobibanking'
};